module.exports = __webpack_public_path__ + "assets/f97875362df61727faf443cb1aa29026.mp3";